import { Button, ColorV2, Text } from "@adoptaunabuelo/react-components";
import styled from "styled-components";
import { useState } from "react";
import InstagramModal, {
	InstagramModalProps,
} from "../../modal/InstagramModal";

const Callout = styled.div`
	display: flex;
	flex-direction: row;
	background-color: ${ColorV2.surface.background};
	padding: 24px;
	border-radius: 16px;
`;
const Col = styled.div`
	display: flex;
	flex: 1;
	flex-direction: column;
`;
const ShareIcon = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 48px;
	width: 48px;
	background-color: white;
	border-radius: 48px;
	margin-left: 12px;
`;

const ShareIGSection = ({ style, ...props }: ShareIGSectionProps) => {
	const [showModal, setShowModal] = useState(false);
	return (
		<Callout style={style}>
			<InstagramModal
				isVisible={showModal}
				onClose={() => setShowModal(false)}
				{...props}
			/>
			<Col>
				<Text type="h5" weight="semibold">
					¿Cómo puedes seguir ayudando?
				</Text>
				<Text type="p2" style={{ marginTop: 8, marginBottom: 16 }}>
					Comparte con todo el mundo tu contibución a nuestro proyecto
					para que más gente se una.
				</Text>
				<Button
					design={"secondary"}
					size="small"
					style={{
						height: 42,
						color: ColorV2.border.neutralHard,
						borderColor: ColorV2.border.neutralHard,
						width: "fit-content",
					}}
					onClick={() => setShowModal(true)}
				>
					{"Compartir"}
				</Button>
			</Col>
			<ShareIcon>
				<Text type="h4" weight="semibold">
					📢
				</Text>
			</ShareIcon>
		</Callout>
	);
};
export default ShareIGSection;
export type ShareIGSectionProps = {
	style?: React.CSSProperties;
} & InstagramModalProps;
